// extracted by mini-css-extract-plugin
export default {"Week":"Gigv5","skeleton-progress":"lYiKI"};